import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { selectPrice } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer, RangeSlider } from "../index";
import { slugify, getCategory } from '../../utils';
import { Router } from "../../routes";

const { ParamsOption } = HotelParamsLine;

const mapStateToProps = state => ({
  price: state.userPreferences.price,
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handlePriceSelection: selectPrice,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class PriceSelector extends Component {
  static propTypes = {
    price: PropTypes.instanceOf(Object),
    handlePriceSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    product: PropTypes.string,
    market: PropTypes.string,
  };

  handlePriceSelect = value => {
    const { handlePriceSelection, product, market } = this.props;

    const priceLo = Number(value.min);
    const priceHi = Number(value.max);

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      priceLo,
      priceHi,
    }, { shallow: true });

    handlePriceSelection({
      priceLo,
      priceHi,
    });
  };

  render() {
    const { handlePriceSelect } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, price } = this.props;
    const priceHi = Number(price.priceHi);
    const priceLo = Number(price.priceLo);

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="price"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'price'}
          isActive={priceLo || priceHi}
        >
          {priceLo || priceHi ? `$${priceLo}-$${priceHi}` : 'Price'}
        </ParamsOption>
        {currentDropdown === 'price' && (
          <DropdownContainer name="price" handleCloseButtonClick={handleCloseDropdown} onClickOutside={handleCloseDropdown}>
            <RangeSlider
              currentMinValue={priceLo && priceLo || 0}
              currentMaxValue={priceHi && priceHi || 300}
              handleSliderChange={handlePriceSelect}
            />
          </DropdownContainer>
        )}
      </Fragment>
    );
  }
}

export default PriceSelector;
